import React from 'react';
import { lazyForPaint, LazySuspense } from 'react-loosely-lazy';
import { jsx as _jsx } from "react/jsx-runtime";
const AtlassianSupportsUkraineSplit = lazyForPaint(() => import(/* webpackChunkName: "chunk-support-ukraine-details" */'./AtlassianSupportsUkraineRoute').then(c => c.default));
export default function AtlassianSupportsUkraineRouteHandler() {
  return /*#__PURE__*/_jsx(LazySuspense, {
    fallback: /*#__PURE__*/_jsx("div", {}),
    children: /*#__PURE__*/_jsx(AtlassianSupportsUkraineSplit, {})
  });
}